/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { FormattedProduct } from '@/store'

export const getIcon = (name: string, suffix: 'svg' | 'png') => {
  return require(`../assets/icons/icon-${name}.${suffix}`)
}

export const getAlertIcon = (type: string) => {
  return require(`../assets/images/errors/icon-${type}.png`)
}

export const getSwiperItemCover = (cover: string, suffix = 'jpg') => {
  return require(`../assets/images/new-works/${cover}.${suffix}`)
}

export const getSerialProductIcon = (product: FormattedProduct) => {
  return require(`../assets/images/new-works/${product.skuId}.jpg`)
}

export const getMaterialImage = (name: string) => {
  return require(`../assets/images/materials/${name}.png`)
}

export const getStackingProductImage = (skuId: string) => {
  return require(`../assets/images/stacking-products/${skuId}.png`)
}

export const getStackingPosterImage = (
  skuId: string,
  type: 'banner' | 'cover' = 'banner'
) => {
  return require(`../assets/images/stacking-posters/${skuId}.${type}.jpg`)
}

export const getProductIcon = (product: FormattedProduct) => {
  const pluralSuffix = product.category.value === 'WATCH' ? 'es' : 's'
  try {
    return require(`../assets/images/${
      product.category.value.toLocaleLowerCase() + pluralSuffix
    }/${product.skuId}.png`)
  } catch {
    // console.error(
    //   `non-image: ../assets/images/${
    //     product.category.value.toLocaleLowerCase() + pluralSuffix
    //   }/${product.skuId}.webp`
    // )
    return ''
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
// export const getStackingIcon = (product: any): any => {
//   return require(`../assets/images/stackings/${product.guid}.jpg`)
// }

// 将base64字符串转换为Blob对象
export const base64ToURL = (base64: string) => {
  const binary = atob(base64.split(',')[1])
  const array = []
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i))
  }

  return URL.createObjectURL(
    new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
  )
}

export const cropBase64Image = async (
  base64: string,
  x: number,
  y: number,
  width: number,
  height: number,
  originWidth: number
) => {
  return new Promise<string>((resolve, reject) => {
    // 创建一个Image对象并将其绘制到Canvas上
    const img = new Image()
    img.onload = function () {
      // 获取图片的实际宽高
      const { naturalWidth, naturalHeight } = img
      // console.log(
      //   '[ originWidth & clientWidth ]',
      //   originWidth,
      //   window.document.body.clientWidth
      // )

      // 创建Canvas并获取上下文
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const dpr = naturalWidth / originWidth
      canvas.width = width * dpr
      canvas.height = height * dpr

      if (ctx) {
        // 将图片绘制到Canvas上
        ctx.drawImage(img, -x * dpr, -y * dpr, naturalWidth, naturalHeight)

        // 将裁剪后的画布内容转换为base64字符串
        const croppedBase64 = canvas.toDataURL()

        // 调用回调函数并传入裁剪后的base64字符串
        resolve(croppedBase64)
      } else {
        reject('no 2d context')
      }
    }
    img.onerror = (event, source, lineno, colno, error) => {
      reject((error || event).toString())
    }
    img.src = base64ToURL(base64)
  })
}
